import { createClient } from "@supabase/supabase-js";

let client = null;

export const initSupabase = (url, anonKey) => {
  if (!client) {
    client = createClient(url, anonKey, {
      auth: { flowType: "pkce", detectSessionInUrl: true, persistSession: true, autoRefreshToken: true },
    });
  }
  return client;
};

export const getSupabase = () => client;
